<!-- 注意：
     1. Thread id 是通过 Comment vue 在构造 Thread component 的时候通过 id 属性注入的
     2. Thread id 有一个前缀 comment-，其目的是在新增评论的时候，便于 jquery 查找的时候能够精确查找，并滑动定位到该评论上。
-->
<template>
    <el-row :style="{'margin-top': threadSpacing}" class="thread" :id="'comment-'+threadId">
        <!-- avatar -->
        <el-col :span="4" align="left">
            <avatar :hash="username" :size="avatarSize"></avatar>
        </el-col>
        <!-- comment -->
        <el-col :span="20" align="left">
            <el-card shadow="never" body-style="padding: 0 0 0 0;" >
                <div class="username margin-bottom-8px">{{username}}</div>
                <div class="content" style="white-space: pre-wrap;">{{content}}</div>
                <div class="tail margin-top-8px">
                    <span>{{timestamp}}</span>
                    <span class="margin-left-6px">
                        <iconfont-selector-tooltip :is-actived="isLiked_" ref="likes"
                                                   default-class="iconfont icon-sy-thumb-up"
                                                   actived-class="iconfont icon-sy-thumb-up-fill"
                                                   actived-color="#ed4956"
                                                   :font-size="16"
                                                   :line-height="12"
                                                   @change="handleLikes"
                                                   tooltip-text="点赞该评论" />
                    </span>
                    <span class="font-normal margin-left-2px">{{likesHrd}}</span> <!-- 将点赞数单独拧出来是为了纵向居中对其 -->
                    <el-link class="reply margin-left-8px" :underline="false" @click="reply(threadId, username)">回复</el-link>
                    <tipoff type="thread" :id="threadId">
                        <my-link class="margin-left-8px tipoff-link">举报</my-link>
                    </tipoff>
                </div>
            </el-card>
            <!-- 用来添加二级评论 -->
            <slot></slot>
        </el-col>
    </el-row>
</template>

<script>
    import HRN from 'human-readable-numbers';
    import assert from 'assert';
    import {CachedApiSecurity} from "../../api-security";
    import {getCachedUser, errorMessage, Comment} from "../../utils";
    import {likes} from "../../data/comment";

    export default {
        name: "Thread",
        components: {
        },
        props: {
            avatarSize: {
                type: Number,
                default: 35
            },
            threadId: Number|String, // the thread id
            rootId: Number|String,   // the first level id
            username: String,
            content: String,
            likes: {
                type: Number,
                default: 0
            },
            isLiked: Boolean,
            // likesBy: {
            //     type: Array,
            //     default: () => { return [] }
            // },
            timestamp: String,
            threadSpacing: {
                type: String,
                default: '20px'
            }
        },
        data() {
            return {
                likes_: this.likes,
                isLiked_: this.isLiked
            }
        },
        computed: {
            // TODO_ 验证，如果评论数(this.likes)发生变化后，likes.hrn 是否会自动的更新？
            // 试验过了，是可以的，每当 this.likes 的值发生了改变，likes_hrn computed 都会被触发重新计算。
            likesHrd: function(){
                console.log('likes_hrn called, this.likes', this.likes);
                return HRN.toHumanString(this.likes_);
            },

            /**
             * @deprecated 通过 likesBy 得到 isliked 的逻辑现在已经由后端负责处理了。
             */
            __isLiked: function(){
                let isLiked = false;
                let user = getCachedUser();
                if(user !== undefined && user !== null)
                    isLiked = this.likesBy.includes(user.username);
                else
                    isLiked = false;
                return isLiked;
            }
        },
        methods: {
            /**
             *
             * @param id the target thread id reply to
             * @param username, reply to who, will be used to form up @username.
             */
            reply(id, username){
                console.log('reply to the thread:', username, id, this.rootId);
                this.$EventBus.$emit('reply', username, 'comment-'+id, this.rootId);
            },
            setLikes(likes) {
                this._likes = likes;
            },
            handleLikes(isActived){
                console.log('Thread.handleLikes, isActived:', isActived);
                if( !CachedApiSecurity.isSignedIn() ) {
                    console.log('the user has not cached signed in');
                    CachedApiSecurity.handleNoAuthorith();
                    this.$refs.likes.revert();
                }else{
                    (async()=>{
                        try{
                            let isLikes = isActived;
                            if (isLikes)
                                this.__likes();
                            else
                                this.__dislikes();
                            await likes(this.threadId, isLikes);
                        }catch(error){
                            console.error(error);
                            errorMessage(error.message);
                            // revert.
                            if (isLikes)
                                this.__dislikes();
                            else
                                this.__likes();
                            this.$refs.likes.revert();
                        }
                    })();
                }
            },

            __likes(){
                this.isLiked_ = true;
                this.likes_ += 1;
                console.log(`thread likes done, is_liked: ${this.isLiked_}, likes: ${this.likes_}`);
                // 以下的逻辑已经被 deprecated，前端不再从 likes_by 中 resolved 得到是否 isliked.
                // let username = getCachedUser().username;
                // if(!self.likes_by.includes(username)){
                //     self.likes_by.push(username);
                //     self.likes += 1;
                // }
            },

            __dislikes(){
                this.isLiked_ = false;
                this.likes_ -= 1;
                console.log(`thread dislikes done, is_liked: ${this.isLiked_}, likes: ${this.likes_}`);
                // 以下的逻辑已经被 deprecated，前端不再从 likes_by 中 resolved 得到是否 isliked.
                // let username = getCachedUser().username;
                // if(self.likes_by.includes(username)){
                //     _.remove(self.likes_by, (username_) => {return username_ === username} );
                //     self.likes -= 1;
                // }
            }
        }
    }
</script>

<style scoped>

    /deep/ .el-row{
        position: static;
    }

    /* 消除 el-card 默认的 1px gray border */
    .el-card {
        border: 0px;
    }

    .username {
        font-weight: 600;
    }

    .tail {
        display: flex;
        align-items: center;
        font-size:12px;
        line-height: 14px; /* 这样才能让 tipoffs 高度居中对齐 */
        color: #909399;
    }

    .tail .reply{
        font-size: 12px;
        font-weight:400;
        color: #303133;
        cursor:pointer
    }

    /deep/ .el-link--inner:hover{
        color: #CB0101;
    }

    /* h5 中已经禁止了长按事件，但是 caption 信息是允许用户复制的，便于用户发标内容 */
    .thread .content{
        -webkit-user-select: auto !important;
        user-select:auto !important;
    }

    .tipoff-link {
        font-size: 12px !important;
        font-weight: 400 !important;
        color: #303133
    }

</style>



// WEBPACK FOOTER //
// src/components/comments/Thread.vue